import React from "react";

type ComponentRenderers = {
  [key: string]: (chunks: React.ReactNode) => React.ReactElement;
};

export const transformText = (
  text: string,
  components: ComponentRenderers
): React.ReactNode[] => {
  const regex = /<(\w+)>(.*?)<\/\1>/g;
  let match: RegExpExecArray | null;
  const result: React.ReactNode[] = [];
  let lastIndex = 0;
  let keyIndex = 0;

  while ((match = regex.exec(text)) !== null) {
    // Add the text before the match
    if (match.index > lastIndex) {
      result.push(text.substring(lastIndex, match.index));
    }

    const componentName = match[1];
    const componentContent = match[2];

    if (components[componentName]) {
      const key = `${componentName}-${keyIndex}-${componentContent}`;
      const componentElement = components[componentName](componentContent);
      result.push(React.cloneElement(componentElement, { key }));
      keyIndex++;
    } else {
      result.push(componentContent);
    }

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    result.push(text.substring(lastIndex));
  }

  return result;
};
